import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"currentColor\" class=\"\" viewBox=\"0 0 18 18\" id=\"icon-down\">\n<path d=\"M7.5 12.5612C8.25 13.6862 9.52762 13.7861 10.125 12.9362L16.125 6.93621C17.5001 5.5 16.9998 4.00004 14.9287 4.31121L8.99984 8.00004L3 4.31121C0.999836 4.00004 1.00004 6.00004 1.875 6.93621L7.5 12.5612Z\" />\n\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol